/** Normalize guest gender for API + franchise catalog filters. */
export function normalizeSalonGenderForApi(value) {
  const g = String(value || '').trim().toLowerCase();
  if (g === 'male' || g === 'm' || g === 'men' || g === 'man') return 'male';
  if (g === 'female' || g === 'f' || g === 'women' || g === 'woman') return 'female';
  return null;
}

export function salonGenderDisplayLabel(value) {
  const api = normalizeSalonGenderForApi(value);
  if (api === 'male') return 'Male';
  if (api === 'female') return 'Female';
  return '';
}

export function hasSalonGender(value) {
  return Boolean(normalizeSalonGenderForApi(value));
}
